import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { DialogForm, FormComboBox } from "@advosys/component-react";
import { getObjectWithValues, useForm, useValidationRules } from "@advosys/component-react-form";
import { saveLanguage } from "src/core";
import { k } from "./settings-dialog-i18n";
export const SettingsDialog = ({ onOk, onCancel }) => {
    const { i18n, t } = useTranslation();
    const { required } = useValidationRules();
    const { formState, formController, hasUnsavedChanges, validateForm } = useForm({
        submitting: false,
        validation: {
            validators: {
                language: () => [required]
            }
        },
        initialValues: {
            values: {
                language: i18n.language
            },
            dependencies: [i18n.language]
        }
    });
    const languageOptions = useMemo(() => [
        { key: "da", text: t(k.languageDa) },
        { key: "en", text: t(k.languageEn) }
    ], [i18n.language]);
    const handleSubmit = () => {
        if (validateForm()) {
            const values = getObjectWithValues(formController, formState);
            i18n.changeLanguage(values.language);
            saveLanguage(values.language);
            onOk();
        }
    };
    return (_jsx(DialogForm, { dialogProps: { header: t(k.dialogHeader), size: "small" }, hasUnsavedChanges: hasUnsavedChanges, isSubmitting: false, onSubmit: handleSubmit, cancel: { onCancel }, children: _jsx(FormComboBox, { label: t(k.languageLabel), formFieldState: formState.language, formFieldController: formController.language, options: languageOptions, width: "100%" }) }));
};
